// load templates
require('./header-template.html');

// create ngModule
angular.module('bbl.layout.header', ['ngMd5'])
  .controller('HeaderController', ['$scope', '$rootScope', 'Auth', Controller]);

function Controller ($scope, $rootScope, Auth) {
  $scope.user = Auth.userInfo;

  $scope.showSidebar = function() {
    $rootScope.$broadcast('show:sidebar');
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/header-controller.js
 ** module id = 80
 ** module chunks = 0
 **/